<swiper [config]="config" [initialize]="true" #usefulSwiper>
    <div class="swiper-wrapper">
        <ng-container *ngIf="images?.length">
            <ng-container *ngFor="let image of (images?.length < 10 ? images : slicedImages); let i = index">
                <figure class="swiper-slide">
                    <div class="allotement" *ngIf="allotment <= 5 && !unavailable">
                        <span translate="no" class="material-icons">whatshot</span>
                        Resta(m) {{allotment < 0 ? 0 : allotment}} {{allotment === 1 ? 'unidade' : 'unidade(s)'}}
                    </div>

                    <img *ngIf="image.src" [src]="imgServer + image.src" class="img-fluid">
                    <img *ngIf="!image.src" src="assets/images/no-image.png" class="img-fluid">
                </figure>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!images?.length">
            <figure class="swiper-slide">
                <div class="allotement" *ngIf="allotment <= 5 && !unavailable">
                    <span translate="no" class="material-icons">whatshot</span>
                    Resta(m) {{allotment < 0 ? 0 : allotment}} {{allotment === 1 ? 'unidade' : 'unidade(s)'}}
                </div>

                <img src="assets/images/no-image.png" class="img-fluid">
            </figure>
        </ng-container>

    </div>
    <!-- Add Arrows -->
<!--    <div class="swiper-pagination"></div>-->
    <div class="images-pagination swiper-pagination"></div>
</swiper>

<div class="slide-modal" [id]="'imgModal-' + roomId">
    <span (click)="closeModal()" class="close-modal">
        <i class="material-icons notranslate">close</i>
    </span>
    <div (click)="closeModal()" class="slide-modal-content">

        <div *ngFor="let image of images; let i = index" [class]="'img-slides-' + roomId">
            <img [src]="imgServer + image.src" class="w-90">
        </div>
    </div>
    <ng-container *ngIf="images.length > 1">
        <a (click)="plusSlides(-1)" class="prev material-icons">arrow_back</a>
        <a (click)="plusSlides(1)" class="next material-icons">arrow_forward</a>
    </ng-container>
</div>

